"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;
var _api = require("@/views/applet/setting/pageList/api");
var _enum = require("../../enum");
var _validate = require("@/utils/validate");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _default(_ref) {
  var handleSearch = _ref.handleSearch,
    userType = _ref.userType;
  var isMiniProgramCustomer = Number(userType) === 5;
  var FILTER_ITEMS = [{
    type: 'input',
    prop: 'name',
    label: '页面名称',
    placeholder: '请输入页面名称',
    clearable: true
  }].concat(_toConsumableArray(!isMiniProgramCustomer ? [{
    type: 'select',
    prop: 'customerId',
    label: '归属客户',
    placeholder: '请选择归属客户',
    options: [],
    attrs: {
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': function remoteMethod(query) {
        return getCustomerOptions(query);
      }
    },
    events: {
      'visible-change': function visibleChange(visible) {
        if (visible) {
          getCustomerOptions('');
        }
      },
      change: function change(value) {
        return handleSearch({
          customerId: value
        });
      }
    }
  }] : []), _toConsumableArray(!isMiniProgramCustomer ? [{
    type: 'select',
    prop: 'appId',
    label: '应用小程序',
    placeholder: '请选择应用小程序',
    options: [],
    attrs: {
      filterable: true,
      remote: true,
      clearable: true,
      'remote-method': function remoteMethod(query) {
        return getAppOptions(query);
      }
    },
    events: {
      'visible-change': function visibleChange(visible) {
        if (visible) {
          getAppOptions('');
        }
      },
      input: function input(value) {
        if (value) {
          getAppOptions(value);
        }
      },
      change: function change(value) {
        return handleSearch({
          appId: value
        });
      }
    }
  }] : []), [{
    type: 'select',
    label: '页面类型：',
    prop: 'type',
    attrs: {
      placeholder: '请选择页面类型',
      clearable: true
    },
    options: _enum.pageType,
    events: {
      change: function change(value) {
        return handleSearch({
          type: value
        });
      }
    }
  }, {
    type: 'select',
    label: '页面状态：',
    prop: 'status',
    attrs: {
      placeholder: '请选择页面状态',
      clearable: true
    },
    options: _enum.pageStatus,
    events: {
      change: function change(value) {
        return handleSearch({
          status: value
        });
      }
    }
  }]);
  function findFilterItem(prop) {
    return FILTER_ITEMS.find(function (item) {
      return item.prop === prop;
    });
  }

  // 获取归属客户下拉选项
  function getCustomerOptions() {
    return _getCustomerOptions.apply(this, arguments);
  } // 使用防抖函数包装获取应用小程序选项
  function _getCustomerOptions() {
    _getCustomerOptions = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var query,
        filterItem,
        res,
        _args2 = arguments,
        _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            query = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
            filterItem = findFilterItem('customerId');
            if (filterItem) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2);
          case 1:
            _context2.p = 1;
            _context2.n = 2;
            return (0, _api.customersListApi)({
              name: query,
              types: 3
            });
          case 2:
            res = _context2.v;
            filterItem.options = (res || []).map(function (item) {
              return {
                value: item.id,
                label: item.name
              };
            });
            _context2.n = 4;
            break;
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            filterItem.options = [];
          case 4:
            return _context2.a(2);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return _getCustomerOptions.apply(this, arguments);
  }
  var debouncedGetAppOptions = (0, _validate.Debounce)(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
    var query,
      filterItem,
      res,
      _args = arguments,
      _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          query = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
          filterItem = findFilterItem('appId');
          if (filterItem) {
            _context.n = 1;
            break;
          }
          return _context.a(2);
        case 1:
          _context.p = 1;
          _context.n = 2;
          return (0, _api.companyappAutoListApi)({
            name: query
          });
        case 2:
          res = _context.v;
          // Check what data format is returned and handle accordingly
          if (res && Array.isArray(res.data)) {
            // If res.data is an array
            filterItem.options = res.data.map(function (item) {
              return {
                value: item.id,
                label: item.appName
              };
            });
          } else if (res && Array.isArray(res)) {
            // If res itself is the array
            filterItem.options = res.map(function (item) {
              return {
                value: item.id,
                label: item.appName
              };
            });
          } else {
            console.error('Unexpected API response format:', res);
          }
          _context.n = 4;
          break;
        case 3:
          _context.p = 3;
          _t = _context.v;
          console.error('Failed to fetch app options:', _t);
        case 4:
          return _context.a(2);
      }
    }, _callee, null, [[1, 3]]);
  })), 300);

  // 获取应用小程序下拉选项
  function getAppOptions(query) {
    debouncedGetAppOptions(query);
  }

  // 初始化加载筛选项
  if (!isMiniProgramCustomer) {
    getCustomerOptions('');
    getAppOptions('');
  }
  return {
    FILTER_ITEMS: FILTER_ITEMS
  };
}